require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ausflug-ins-innere.json") })
        }
      }, "path---ausflug-ins-innere");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ausflug-ins-innere!./.cache/json/ausflug-ins-innere.json
// module id = 410
// module chunks = 231608221292675